import { render, staticRenderFns } from "./ReservationTrashCan.vue?vue&type=template&id=378ecb4e&"
import script from "./ReservationTrashCan.vue?vue&type=script&lang=ts&"
export * from "./ReservationTrashCan.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationTrashCan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports